"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * generuje guid w formacie xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 */
function generateGuid() {
    var g = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return g.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line:no-bitwise
        var r = (Math.random() * 16) | 0;
        // tslint:disable-next-line:no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
    // return g;
}
exports.default = generateGuid;
//# sourceMappingURL=generateGuid.js.map